module.exports = __webpack_public_path__ + "img/国际城市预报@2x.b613a840.png";